import { useEffect } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { updateAcademicLevel } from "../../services/school/academicLevel";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { AcademicLevelType } from "../../types/AcademicLevelType";
import { AcademicLevelFormValidation } from "./AcademicLevelFormValidation";
import { resetAcademicLevelData } from "../../redux/slices/school/academicLevel";

export const UpdateAcademicLevel = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const academicLevelData = useAppSelector((state) => state.academicLevel);
    
    const mutation = useMutation({ mutationFn: updateAcademicLevel, mutationKey: "updateAcademicLevel" });

    const { control, handleSubmit, formState: { errors }, reset } = useForm<AcademicLevelType>({
        resolver: yupResolver(AcademicLevelFormValidation),
        defaultValues: academicLevelData,
        mode: "onBlur",
    });



    const onSubmit = handleSubmit(async (data) => {
        try {
            await mutation.mutateAsync(data);
            toast.success("Nível Académico actualizado com sucesso!");
            navigate(routes.academicLevels);
            dispatch(resetAcademicLevelData()); 
        } catch (err) {
            toast.error("Erro ao actualizar Nível Académico");
        }
    });

    const handleBack = () => {
        dispatch(resetAcademicLevelData()); 
        navigate(routes.academicLevels);
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <TextFieldComponent 
                        name="description" 
                        label="Nome" 
                        control={control} 
                        errors={errors} 
                        required={true} 
                    />
                    {/* <TextFieldComponent 
                        name="code" 
                        label="Código" 
                        control={control} 
                        errors={errors} 
                        required={true} 
                    /> */}

                    <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                        <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> Voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading} variant="surface">
                            {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                            Actualizar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
